import React, { Component, createRef } from "react";
import {
  addDays,
  differenceInCalendarDays,
  differenceInMonths,
  endOfMonth,
  format,
  getMonth,
  getYear,
  isAfter,
  isBefore,
  isFriday,
  isMonday,
  isSameDay,
  isSaturday,
  isThursday,
  isTuesday,
  isWednesday,
  startOfMonth,
  startOfToday,
  subDays,
} from "date-fns";

import cf from "../../../../lib/utils/common";
import moment from "moment";

// import styles from "./calendar.module.css";

const weekList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default class DesktopCalender extends Component {
  constructor(props) {
    super(props);
    this.calendarWrapper = createRef();
    this.DateCellWrapper = createRef();
    this.state = {
      dateFormat: !cf.isValueEmpty(this.props.dateFormat)
        ? this.props.dateFormat
        : "",
      numberOfClicks: 0,
      twoCalendarsArray: [],
      isDoubleSelection: !cf.isValueEmpty(this.props.doubleSelection)
        ? this.props.doubleSelection
        : false,
      dateLimitArr: this.props.startDateLimit,
      currentMonths: [getMonth(startOfMonth(new Date()))],
      selectedMonthStartDate: startOfMonth(startOfToday()),
      selectedMonthEndDate: endOfMonth(startOfMonth(new Date())),
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      hoverEndDate: this.props.endDate,
      totalDays: "",
      totalNights: "",
      pageX: "",
      pageY: "",
      initPageX: "",
      initPageY: "",
    };
  }
  componentDidMount() {
    console.log("props...", this.props);
    console.log("state...", this.state);
    this.setState({
      currentMonths:
        this.props.type === "double"
          ? !cf.isValueEmpty(this.state.dateLimitArr)
            ? [
              getMonth(
                startOfMonth(
                  new Date(
                    this.specDateEle(this.state.dateLimitArr, "y"),
                    this.specDateEle(this.state.dateLimitArr, "m"),
                    this.specDateEle(this.state.dateLimitArr, "d")
                  )
                )
              ),
              getMonth(
                startOfMonth(
                  new Date(
                    this.specDateEle(this.state.dateLimitArr, "y"),
                    this.specDateEle(this.state.dateLimitArr, "m"),
                    this.specDateEle(this.state.dateLimitArr, "d")
                  )
                )
              ) + 1,
            ]
            : [
              getMonth(startOfMonth(new Date())),
              getMonth(startOfMonth(new Date())) + 1,
            ]
          : !cf.isValueEmpty(this.state.dateLimitArr)
            ? [
              getMonth(
                startOfMonth(
                  new Date(
                    this.specDateEle(this.state.dateLimitArr, "y"),
                    this.specDateEle(this.state.dateLimitArr, "m"),
                    this.specDateEle(this.state.dateLimitArr, "d")
                  )
                )
              ),
            ]
            : [getMonth(startOfMonth(new Date()))],
      selectedMonthStartDate: !cf.isValueEmpty(this.state.startDate)
        ? startOfMonth(
          new Date(
            this.specDateEle(this.state.startDate, "y"),
            this.specDateEle(this.state.startDate, "m"),
            this.specDateEle(this.state.startDate, "d")
          )
        )
        : startOfMonth(startOfToday()),
    });
    document.addEventListener("mousedown", this.handleClickOutside, false);
    document.addEventListener("keydown", this.handleTabOutside, false);
    window.addEventListener("mousemove", this.logMousePosition, false);
  }
  componentDidUpdate() {
    if (this.props.endDate !== this.state.endDate) {
      this.setState({ endDate: this.props.endDate });
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
    document.removeEventListener("keydown", this.handleTabOutside, false);
    document.removeEventListener("mousemove", this.logMousePosition, false);
  }

  //   componentWillReceiveProps(nextProps) {
  //     if (nextProps.startDateLimit ) {
  //         this.setState({
  //             dateLimitArr:nextProps.startDateLimit,
  //             startDate:nextProps.startDate
  //         },()=>{
  //             this.setState({
  //                 currentMonths: this.props.type === "double" ?
  //                  !cf.isValueEmpty(this.state.dateLimitArr) ?
  //                     [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))),getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))) + 1] :
  //                     [getMonth(startOfMonth(new Date())), getMonth(startOfMonth(new Date())) + 1] : !cf.isValueEmpty(this.state.dateLimitArr) ?
  //                     [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))))] :
  //                     [getMonth(startOfMonth(new Date()))],
  //                     selectedMonthStartDate: !cf.isValueEmpty(this.state.startDate) ? startOfMonth(new Date(this.specDateEle(this.state.startDate, 'y'), this.specDateEle(this.state.startDate, 'm'), this.specDateEle(this.state.startDate, 'd'))) : startOfMonth(startOfToday()),
  //                 })
  //         })
  //     }
  // }
  handleTabOutside = (e) => {
    if (e.key !== "Tab") {
      return;
    }
    if (
      this.calendarWrapper.current &&
      !this.calendarWrapper.current.contains(event.target)
    ) {
      this.props.changeVisibility(false);
    }
  };
  handleClickOutside = (event) => {
    if (
      this.calendarWrapper.current &&
      !this.calendarWrapper.current.contains(event.target)
    ) {
      this.props.changeVisibility(false);
    }
  };
  logMousePosition = (event) => {
    if (this.props.isVisible) {
      if (
        this.calendarWrapper.current &&
        !this.calendarWrapper.current.contains(event.target)
      ) {
      }
    }
  };
  specDateEle(date, type) {
    try {
      let getDate = cf.isValueEmpty(this.state.dateFormat)
        ? moment(new Date(date)).format("DD/MMM/yyyy")
        : moment(date).format(this.state.dateFormat);
      let getYear =
        typeof date === "string"
          ? new Date(getDate).getFullYear()
          : date.getFullYear();
      let getMonth =
        typeof date === "string"
          ? new Date(getDate).getMonth()
          : date.getMonth();
      let getDay =
        typeof date === "string" ? new Date(getDate).getDate() : date.getDate();
      switch (type) {
        case "y":
          return getYear;
        case "m":
          return getMonth;
        case "d":
          return getDay;
        case "a":
          return [getYear, getMonth, getDay];
        default:
      }
    } catch (err) {
      console.log("catch yyyyy", err);
    }
  }

  onClickChangeVisibility = () => {
    this.props.changeVisibility(true);
  };

  onClickClearDate = () => {
    this.props.changeVisibility(false);
    this.props.onClearDate();
  };

  onClickPrevNextArrow = (type) => {
    let startMonth = subDays(this.state.selectedMonthStartDate, 1);
    let endMonth = addDays(this.state.selectedMonthEndDate, 1);
    if (this.props.type === "double") {
      if (type === "prev") {
        this.state.currentMonths[1] = getMonth(startMonth) - 1;
      } else {
        this.state.currentMonths[1] = getMonth(endMonth) + 1;
      }
    }
    if (type === "prev") {
      this.state.currentMonths[0] =
        getMonth(this.state.selectedMonthStartDate) - 1;
      this.setState({
        currentMonths: [...this.state.currentMonths],
        selectedMonthStartDate: startOfMonth(startMonth),
        selectedMonthEndDate: endOfMonth(startMonth),
      });
    } else {
      this.state.currentMonths[0] =
        getMonth(this.state.selectedMonthStartDate) - 1;
      this.setState({
        currentMonths: [...this.state.currentMonths],
        selectedMonthStartDate: startOfMonth(endMonth),
        selectedMonthEndDate: endOfMonth(endMonth),
      });
    }
  };
  onClickDateCell = (day, month, year, bool) => {
    if (!bool) {
      //new added
      if (this.state.isDoubleSelection === true) {
        let date = new Date(year, month, day);
        if (this.state.numberOfClicks === 0) {
          let difference = differenceInCalendarDays(
            new Date(addDays(new Date(date), 1)),
            new Date(date)
          );
          this.setState(
            {
              numberOfClicks: 1,
              totalNights: difference > 0 ? difference : "",
            },
            () => {
              this.props.onChangeDate(date, "startDate");
              this.props.onChangeDate(addDays(new Date(date), 1), "endDate");
            }
          );
        }
        if (this.state.numberOfClicks === 1) {
          let differenceInDays = differenceInCalendarDays(
            new Date(date),
            new Date(this.props.startDate)
          );
          this.setState(
            {
              numberOfClicks: 0,
              totalNights: differenceInDays > 0 ? differenceInDays : "",
            },
            () => {
              if (differenceInDays < 0) {
                this.props.onChangeDate(date, "startDate");
                this.props.onChangeDate(addDays(new Date(date), 1), "endDate");
              } else {
                this.setState({ numberOfClicks: 0 }, () => {
                  this.props.onChangeDate(date, "endDate");
                  this.props.changeVisibility(!this.props.isVisible);
                  // Trigger callback to open pax component after end date is selected
                  if (typeof this.props.onEndDateSelected === "function") {
                    setTimeout(() => {
                      this.props.onEndDateSelected();
                    }, 100);
                  }
                });
              }
            }
          );
        }
      } else {
        if (bool === false) {
          let date = new Date(year, month, day);
          this.props.onChangeDate(date);
          this.props.changeVisibility(!this.props.isVisible);
        }
      }
    }
  };
  renderCalendar() {
    let temp = this.state.selectedMonthStartDate;
    let twoCalendarsArray = [];
    for (let i = 0; i < this.state.currentMonths.length; i++) {
      let StartDateOfMonth = temp;
      let monthHead = addDays(StartDateOfMonth, i);
      let endDateOfMonth = endOfMonth(monthHead);
      let dayDifference = differenceInCalendarDays(endDateOfMonth, monthHead);
      let days = [];
      let month = getMonth(monthHead);
      let year = getYear(monthHead);
      let startOfMonthDay = isMonday(monthHead)
        ? 0
        : isTuesday(monthHead)
          ? 1
          : isWednesday(monthHead)
            ? 2
            : isThursday(monthHead)
              ? 3
              : isFriday(monthHead)
                ? 4
                : isSaturday(monthHead)
                  ? 5
                  : 6;
      let startDateLimit = this.props.startDateLimit;
      let isHoliday = this.props.isHoliday ? this.props.isHoliday : false;
      let holidayStartDate = this.props.holidayStartDate
        ? this.props.holidayStartDate
        : "";
      let holidayEndDate = this.props.holidayEndDate
        ? this.props.holidayEndDate
        : "";
      let startDate = this.props.startDate;
      let endDate = this.state.endDate;
      let hoverDate = this.state.hoverEndDate;
      for (let k = 0; k < startOfMonthDay; k++) {
        days = [
          ...days,
          {
            day: "",
            month: month,
            year: year,
            isDisable: true,
            selectedDate: false,
            highlight: false,
          },
        ];
      }
      for (let j = 0; j <= dayDifference; j++) {
        let isBeforeDate = isBefore(
          new Date(year, month, j + 1),
          new Date(
            this.specDateEle(startDateLimit, "y"),
            this.specDateEle(startDateLimit, "m"),
            this.specDateEle(startDateLimit, "d")
          )
        );
        // Disable all dates before the selected check-in date (startDate) if it exists
        let isBeforeCheckIn = false;
        if (this.props.startDate) {
          isBeforeCheckIn = isBefore(
            new Date(year, month, j + 1),
            new Date(
              this.specDateEle(this.props.startDate, "y"),
              this.specDateEle(this.props.startDate, "m"),
              this.specDateEle(this.props.startDate, "d")
            )
          );
        }
        let disableDate = false;
        if (isHoliday) {
          let isHLDBeforeDate = isBefore(
            new Date(year, month, j + 1),
            new Date(
              this.specDateEle(holidayStartDate, "y"),
              this.specDateEle(holidayStartDate, "m"),
              this.specDateEle(holidayStartDate, "d")
            )
          );
          let isHLDAfterDate = isAfter(
            new Date(year, month, j + 1),
            new Date(
              this.specDateEle(holidayEndDate, "y"),
              this.specDateEle(holidayEndDate, "m"),
              this.specDateEle(holidayEndDate, "d")
            )
          );
          disableDate =
            isHLDBeforeDate == true || isHLDAfterDate == true ? true : false;
        }
        let isAfterThirtyNights = isAfter(
          new Date(year, month, j + 1),
          addDays(new Date(this.props.startDate), 30)
        );
        if (
          isBeforeDate === true ||
          disableDate == true ||
          isBeforeCheckIn === true ||
          (isAfterThirtyNights == true && this.state.numberOfClicks !== 0)
        ) {
          days = [
            ...days,
            {
              day: j + 1,
              month: month,
              year: year,
              isDisable: true,
              selectedDate: false,
              highlight: false,
            },
          ];
        } else {
          days = [
            ...days,
            {
              day: j + 1,
              month: month,
              year: year,
              isDisable: false,
              selectedDate:
                year == this.specDateEle(startDate, "y") &&
                  month == this.specDateEle(startDate, "m") &&
                  j + 1 == this.specDateEle(startDate, "d")
                  ? true
                  : false,
              highlight:
                year == this.specDateEle(hoverDate, "y") &&
                  month == this.specDateEle(hoverDate, "m") &&
                  j + 1 == this.specDateEle(hoverDate, "d")
                  ? true
                  : false,
            },
          ];
        }
      }
      if (this.state.isDoubleSelection === true) {
        let startDateIndex = days.findIndex(
          (items) =>
            !cf.isValueEmpty(items.day) &&
            new Date(items.year, items.month, items.day).toString() ===
            new Date(
              this.specDateEle(startDate, "y"),
              this.specDateEle(startDate, "m"),
              this.specDateEle(startDate, "d")
            ).toString()
        );
        let endDateIndex = days.findIndex(
          (items) =>
            !cf.isValueEmpty(items.day) &&
            new Date(items.year, items.month, items.day).toString() ===
            new Date(
              this.specDateEle(endDate, "y"),
              this.specDateEle(endDate, "m"),
              this.specDateEle(endDate, "d")
            ).toString()
        );
        if (startDateIndex !== -1) {
          days[startDateIndex].selectedDate = true;
        }
        if (endDateIndex !== -1) {
          days[endDateIndex].selectedDate = true;
        }
      } else {
        let SelectedDate = this.props.value;
        let selectedDateIndex = days.findIndex(
          (items) =>
            new Date(items.year, items.month, items.day).toString() ===
            new Date(
              this.specDateEle(SelectedDate, "y"),
              this.specDateEle(SelectedDate, "m"),
              this.specDateEle(SelectedDate, "d")
            ).toString()
        );
        if (selectedDateIndex !== -1) {
          days[selectedDateIndex].selectedDate = true;
        }
      }
      temp = endDateOfMonth;
      twoCalendarsArray.push(
        <div className={this.props.styles?.calendar_whole_body}>
          <div className={this.props.styles?.calendar_head}>
            <div className={this.props.styles?.calendar_head_center_side}>
              <h3>{format(monthHead, "MMMM yyyy")}</h3>
            </div>
          </div>
          <div className={this.props.styles?.calendar_body}>
            <div className={this.props.styles?.calendar_week_heads}>
              {weekList.map((ele, idx) => {
                return (
                  <div
                    className={this.props.styles?.coln_center_week}
                    key={"weekl" + idx}
                  >
                    {ele}
                  </div>
                );
              })}
            </div>
            <div className={this.props.styles?.calendar_day_list}>
              {days.map((ele, idx) => {
                let isHighLight = false;
                let isHoverDate = false;
                if (this.state.isDoubleSelection === true) {
                  let isBeforeDate = isBefore(
                    new Date(ele.year, ele.month, ele.day),
                    new Date(
                      this.specDateEle(hoverDate, "y"),
                      this.specDateEle(hoverDate, "m"),
                      this.specDateEle(hoverDate, "d")
                    )
                  );
                  let isBeforeEndDate = isBefore(
                    new Date(ele.year, ele.month, ele.day),
                    new Date(
                      this.specDateEle(endDate, "y"),
                      this.specDateEle(endDate, "m"),
                      this.specDateEle(endDate, "d")
                    )
                  );
                  let isAfterDate = isAfter(
                    new Date(ele.year, ele.month, ele.day),
                    new Date(
                      this.specDateEle(startDate, "y"),
                      this.specDateEle(startDate, "m"),
                      this.specDateEle(startDate, "d")
                    )
                  );
                  isHoverDate = isSameDay(
                    new Date(ele.year, ele.month, ele.day),
                    new Date(
                      this.specDateEle(hoverDate, "y"),
                      this.specDateEle(hoverDate, "m"),
                      this.specDateEle(hoverDate, "d")
                    )
                  );
                  if (
                    (isAfterDate && isBeforeDate && cf.isValueEmpty(endDate)) ||
                    (isAfterDate &&
                      isBeforeEndDate &&
                      !cf.isValueEmpty(endDate))
                  ) {
                    isHighLight = true;
                  }
                }
                return (
                  <div
                    className={
                      ele.selectedDate === true && ele.day
                        ? this.props.styles.day_cell_center +
                        " " +
                        this.props.styles.selected_calendar_date
                        : isHighLight === true && ele.day != ""
                          ? this.props.styles.day_cell_center_highlight
                          : this.props.styles.day_cell_center
                    }
                    key={i}
                    onClick={() =>
                      this.onClickDateCell(
                        ele.day,
                        ele.month,
                        ele.year,
                        ele.isDisable
                      )
                    }
                    onMouseEnter={(e) => this.onHoverDayCell(ele, e)}
                  >
                    {this.state.isDoubleSelection === true &&
                      !cf.isValueEmpty(ele.day) &&
                      ele.isDisable === false &&
                      !cf.isValueEmpty(hoverDate) &&
                      isHoverDate &&
                      !cf.isValueEmpty(this.state.totalDays) && (
                        <div class={this.props.styles?.container_tooltip}>
                          {this.state.totalDays}{" "}
                          {this.state.totalDays > 1 ? "Nights" : "Night"}
                        </div>
                      )}
                    <span
                      className={
                        ele.isDisable === true
                          ? this.props.styles.calendar_day_disable
                          : ""
                      }
                    >
                      {ele.day}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    }
    return twoCalendarsArray;
  }
  onHoverDayCell = (currentDate, e) => {
    let date = moment(
      new Date(currentDate.year, currentDate.month, currentDate.day)
    ).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
    this.setState({
      hoverEndDate: date,
    });
    if (!cf.isValueEmpty(this.props.startDate)) {
      this.setState(
        {
          hoverEndDate: date,
          pageX: Number(e.clientX) - Number(this.state.initPageX),
          pageY: Number(e.clientY) - Number(this.state.initPageY),
        },
        () => {
          let difference = differenceInCalendarDays(
            new Date(currentDate.year, currentDate.month, currentDate.day),
            new Date(this.props.startDate)
          );
          if (difference > 0) this.setState({ totalDays: difference });
          else this.setState({ totalDays: "" });
        }
      );
    }
  };
  onMouseMoveCalendar = (e, eventUsed) => {
    switch (eventUsed) {
      case "onMouseEnter":
        this.setState({ initPageX: e.clientX, initPageY: e.clientY });
        break;
      default:
        break;
    }
    e.preventDefault();
  };
  render() {

    const formatDisplayFromDate = (date) => {
      try {
        if (cf.isValueEmpty(date)) return "";
        const y = this.specDateEle(date, "y");
        const m = this.specDateEle(date, "m");
        const d = this.specDateEle(date, "d");
        return format(new Date(y, m, d), "dd MMM");
      } catch (e) {
        return "";
      }
    };

    const checkInDt =
          !cf.isValueEmpty(this.props.startDate) && formatDisplayFromDate(this.props.startDate)
               ? formatDisplayFromDate(this.props.startDate)
             : !cf.isValueEmpty(this.props.value)
                ? `${this.props.value.split("-")[0]}-${this.props.value.split("-")[1]}`
             : "Start Date";
    
          const checkOutDt =
              !cf.isValueEmpty(this.props.endDate) && formatDisplayFromDate(this.props.endDate)
                  ? formatDisplayFromDate(this.props.endDate)
               : !cf.isValueEmpty(this.props.value)
                  ? `${this.props.value.split("-")[3]}-${this.props.value.split("-")[4]}`
                : "End Date";
    
          const totalNights = this.state.totalNights
        ? `${this.state.totalNights} ${this.state.totalNights > 1 ? "Nights" : "Night"
        }`
        : this.props.startDate && this.props.endDate
          ? `${differenceInCalendarDays(
            new Date(this.props.endDate),
            new Date(this.props.startDate)
          )} Nights`
          : "0 Nights";

    const checkInOutdt = `${checkInDt} - ${checkOutDt}`;
    // const checkInDt = !cf.isValueEmpty(this.props.value)
    //   ? `${this.props.value.split("-")[0]} ${this.props.value.split("-")[1]}`
    //   : this.props.startDate
    //   ? format(new Date(this.props.startDate), "dd MMM")
    //   : "Start Date";

    // const checkOutDt = !cf.isValueEmpty(this.props.value)
    //   ? `${this.props.value.split("-")[3]} ${this.props.value.split("-")[4]}`
    //   : this.props.endDate
    //   ? format(new Date(this.props.endDate), "dd MMM")
    //   : "End Date";

    // const totalNights = this.state.totalNights
    //   ? `${this.state.totalNights} ${
    //       this.state.totalNights > 1 ? "Nights" : "Night"
    //     }`
    //   : this.props.startDate && this.props.endDate
    //   ? `${differenceInCalendarDays(
    //       new Date(this.props.endDate),
    //       new Date(this.props.startDate)
    //     )} Nights`
    //   : "0 Nights";

    // const checkInOutdt = `${checkInDt} - ${checkOutDt}`;



    return (
      <>
        <div
          className={this.props.styles?.select_full_section}
          onClick={() => this.onClickChangeVisibility()}
        ></div>
        <div className={this.props.styles?.calendar_wid_container}>
          <label>{this.props.label}</label>
          <div className={this.props.styles?.calendar_wid_main}>
            {!cf.isValueEmpty(this.props.iconImage) ? (
              <span
                className={this.props.styles?.flight_search_wid_inputfield_img}
                onClick={() => this.onClickChangeVisibility()}
              >
                {this.props.iconImage}
              </span>
            ) : null}

            {this.state.isDoubleSelection === true ? (
              <>
                <div
                  className={this.props.styles?.calendar_input_container}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onClickChangeVisibility();
                  }}
                >
                  <input
                    type="text"
                    autoComplete={"off"}
                    id="myTextField"
                    className="search_widget_input_new"
                    readOnly
                    // placeholder={
                    //   !cf.isValueEmpty(this.props.startDate) &&
                    //     !cf.isValueEmpty(this.props.endDate)
                    //     ? `${format(
                    //       new Date(this.props.startDate),
                    //       "dd MMM"
                    //     )} - ${format(
                    //       new Date(this.props.endDate),
                    //       "dd MMM"
                    //     )}`
                    //     : !cf.isValueEmpty(this.props.placholder)
                    //       ? this.props.placholder
                    //       : "Select Date"
                    // }
                     placeholder={
                    !cf.isValueEmpty(this.props.startDate) &&
                      !cf.isValueEmpty(this.props.endDate)
                        ? `${formatDisplayFromDate(this.props.startDate)} - ${formatDisplayFromDate(
                            this.props.endDate
                          )}`
                        : !cf.isValueEmpty(this.props.placholder)
                        ? this.props.placholder
                        : "Select Date"
                    }
                    // value={
                    //   !cf.isValueEmpty(this.props.value)
                    //     ? this.props.value
                    //     : !cf.isValueEmpty(this.props.startDate) &&
                    //       !cf.isValueEmpty(this.props.endDate)
                    //       ? `${format(
                    //         new Date(this.props.startDate),
                    //         "dd MMM"
                    //       )} - ${format(
                    //         new Date(this.props.endDate),
                    //         "dd MMM"
                    //       )}`
                    //       : ""
                    // }
                   value={
                        !cf.isValueEmpty(this.props.value)
                          ? this.props.value.replace(
                              /(\d{2})-([A-Za-z]{3})(-\d{4})?/g,
                              "$1 $2"
                            )
                          : !cf.isValueEmpty(this.props.startDate) &&
                            !cf.isValueEmpty(this.props.endDate)
                          ? `${formatDisplayFromDate(this.props.startDate)} - ${formatDisplayFromDate(
                              this.props.endDate
                            )}`
                          : ""
                      }

                    onClick={(e) => {
                      e.stopPropagation();
                      this.onClickChangeVisibility();
                    }}

                    onFocus={(e) => {
                      e.stopPropagation();
                      this.onClickChangeVisibility();
                    }}
                    tabindex="2"
                  />
                  <span className={this.props.styles.calendar_per_night}>
                    {totalNights}
                  </span>
                </div>
              </>
            ) : (
              <>
                <input
                  type="text"
                  autoComplete={"off"}
                  id={this?.props?.id || "" + "myTextField"}
                  className="search_widget_input_new"
                  readOnly
                  placeholder={
                    !cf.isValueEmpty(this.props.placholder)
                      ? this.props.placholder
                      : ""
                  }
                  value=
                  {
                    !cf.isValueEmpty(this.props.value) ? this.props.value : ""
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onClickChangeVisibility();
                  }}
                  onFocus={(e) => {
                    /* typeof this.props.onInputFocus === "function" ? this.props.onInputFocus() : () => { } */ e.stopPropagation();
                    this.onClickChangeVisibility();
                  }}
                  tabindex="2"
                />
              </>
            )}
          </div>
          {this.props.isVisible === true ? (
            <div
              ref={this.calendarWrapper}
              onMouseEnter={(e) => this.onMouseMoveCalendar(e, "onMouseEnter")}
              className={
                this.props.type === "double"
                  ? this.props.styles.calendar_container +
                  " " +
                  this.props.styles.calendar_container_double
                  : this.props.styles.calendar_container +
                  " " +
                  this.props.styles.calendar_container_single
              }
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={this.props.styles?.calendar_main}
              >
                {getMonth(this.state.selectedMonthStartDate) !==
                  getMonth(new Date()) ||
                  (differenceInMonths(
                    new Date(this.state.selectedMonthStartDate),
                    new Date()
                  ) < 12 &&
                    differenceInMonths(
                      new Date(this.state.selectedMonthStartDate),
                      new Date()
                    ) >= 1) ? (
                  <div
                    className={this.props.styles?.calendar_head_left_side}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onClickPrevNextArrow("prev");
                    }}
                  >
                    <span
                      className={`${this.props.styles?.calendar_head_icon} ${this.props.styles?.calendar_leftIcon_rotate}`}
                    >
                      <img src="images/eth_Charcoal_Left.svg" alt="arrow" />
                    </span>
                  </div>
                ) : null}
                {differenceInMonths(
                  new Date(this.state.selectedMonthStartDate),
                  new Date()
                ) < 11 ? (
                  <div
                    className={this.props.styles?.calendar_head_right_side}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onClickPrevNextArrow("next");
                    }}
                  >
                    <span className={`${this.props.styles?.calendar_head_icon} ${this.props.styles?.calendar_right_icon}`}>
                      <img src="images/eth_Charcoal_Right.svg" alt="arrow" />
                    </span>
                  </div>
                ) : null}
                {this.renderCalendar()}
              </div>

              <div className={this.props.styles?.holiday}>
                {/* <div className={this.props.styles?.holiday_title} tabIndex="0">
                Holiday
              </div> */}
                <div
                  className={this.props.styles?.holiday_divider}
                  role="separator"
                ></div>
                <div className={this.props.styles?.holiday_footer}>
                  <div className={this.props.styles?.holiday_date}>
                    {checkInOutdt} <span className={this.props.styles?.divider_date_night}>|</span> {totalNights}
                  </div>
                  <div
                    className={this.props.styles?.holiday_clear}
                    tabIndex="0"
                    role="button"
                    onClick={(e) => {
                      this.onClickClearDate();
                    }}
                  >
                    Clear
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}
